import { useGetAllProductTechMapsForLinkPreformTechMapQuery } from '@/shared/state/api/swagger';
import { Divider, Select } from 'antd';
import { FC, useCallback, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import _debounce from 'lodash/debounce';
import { MKSelectPreformProps } from './mk-select.types';
import { NotFoundContentDropdown, useAppSelector } from '@/shared';
import { Flex, useDisclosure, Button } from '@chakra-ui-kraud/react';
import { TechCardPreformFormModal } from '../tech-card-preform-modal';

export const MKSelectPreform: FC<MKSelectPreformProps> = ({ className, onSelect, query, name, ...props }) => {
	const { control, getValues } = useFormContext();
	const userRole = useAppSelector((state) => state.auth.userProfile?.role);

	const { preform_num } = getValues();

	const [numberQuery, setNumberQuery] = useState(null);

	const { data, options, isFetching } = useGetAllProductTechMapsForLinkPreformTechMapQuery(
		{
			stringToSearch: numberQuery ?? undefined,
			num: preform_num?.num || 0,
			...query,
		},
		{
			selectFromResult: (result) => {
				return {
					...result,
					options: result?.data?.map((item) => ({
						value: item.number,
						label: item.number,
					})),
				};
			},
		},
	);

	const debouncedMapSearch = useCallback(
		_debounce((search) => setNumberQuery(search), 300),
		[],
	);

	const { isOpen, onClose, onOpen } = useDisclosure();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				return (
					<>
						<Select
							{...props}
							status={error ? 'error' : ''}
							tabIndex={1}
							showSearch
							placeholder="Поиск..."
							optionFilterProp="children"
							onChange={(e) => {
								onChange(e);
							}}
							style={{
								minWidth: '227px',
								width: '100%',
								...props.style,
								border: error ? '1px solid #FF4D4F' : props.style?.border,
							}}
							filterOption={() => true}
							onSearch={(search) => {
								const number = Number(search);
								if (!Number.isNaN(number)) {
									debouncedMapSearch(search);
								}
							}}
							onSelect={(item) => {
								const selected = data?.find((el) => el.number === item);
								onSelect?.(selected!);
							}}
							value={value}
							options={options}
							className={className}
							notFoundContent={
								<NotFoundContentDropdown
									isFetchingNaming={isFetching}
									alertName={'Введите обозначение'}
								/>
							}
							dropdownRender={(menu) => (
								<>
									{menu}
									{userRole !== 'storekeeper' && (
										<>
											<Divider style={{ margin: '0', marginTop: '4px' }} />
											<Flex justifyContent={'center'} px={1} pt={2}>
												<Button size="sm" variant="ghost" onClick={onOpen} width="100%">
													Создать связь с новой МК
												</Button>
											</Flex>
										</>
									)}
								</>
							)}
						/>
						{isOpen && <TechCardPreformFormModal onCreate={onSelect} isOpen={isOpen} onClose={onClose} />}
					</>
				);
			}}
		/>
	);
};
